import { render, staticRenderFns } from "./CampagnaDetail.vue?vue&type=template&id=0e265261&"
import script from "./CampagnaDetail.vue?vue&type=script&lang=ts&"
export * from "./CampagnaDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports